import { NgModule } from '@angular/core';

/* combined common modules into one file */
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { PdfViewerModule } from 'ng2-pdf-viewer';

/*  angular material  */
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from '../shared/shared.module';

// components & pages
import { GainsightModule } from '../core/gainsight.module';
import { billingReducers } from '../store';
import * as fromComponents from './components';
import * as fromPages from './pages';

@NgModule({
  declarations: [...fromComponents.components, ...fromPages.pages],
  exports: [RouterModule],
  imports: [
    SharedModule,
    RouterModule,
    MatInputModule,
    MatRadioModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatTooltipModule,
    PdfViewerModule,
    MatIconModule,
    StoreModule.forFeature('billing', billingReducers),
    GainsightModule,
  ],
})
export class BillingModule {}
